module.exports = __webpack_public_path__ + "static/media/ArrowIcons.670b2fe0.svg";